import {FC, ReactNode} from 'react';
import {PermissionResponse} from 'types/permissions';

export type SectionProps = {
    children?: ReactNode;
    isActive?: boolean;
    label?: string;
    permission?: PermissionResponse;
};

const Section: FC<SectionProps> = ({children}) => {
    return <div className="flex flex-col">{children}</div>;
};
export default Section;
